import Grid from '@mui/material/Grid';
import {number} from 'prop-types';

import ReportModulesList from '../ReportModulesList/ReportModulesList';
import ReportsList from '../ReportsList/ReportsList';

const ReportsAndModulesStack = ({totalHeightNeededForReportsDisplaying}) => {
  return (
    <Grid container flexDirection="column" flex={1}>
      <ReportsList maxHeight={totalHeightNeededForReportsDisplaying} />
      <ReportModulesList />
    </Grid>
  );
};

ReportsAndModulesStack.propTypes = {
  totalHeightNeededForReportsDisplaying: number.isRequired
};

export default ReportsAndModulesStack;
